<template>
  <main class="main profile-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="profile-info">
            <div class="profile-info-left">
              <div class="profile-image">
                <img :src="user.avatarMedium || require('@/assets/default-profile-icon.svg')" alt="User Avatar" />
              </div>
              <div class="profile-name">{{ fullName }}</div>
              <div class="separator"></div>
              <div class="wallet-info">
                <img src=".././assets/wallet-black.svg" alt="Wallet Icon" class="wallet-info-icon" />
                <div class="balance-info">
                  <div class="balance-text">{{ $t('Balance') }}</div>
                  <div class="balance-amount">
                    <InternalAmount v-if="internalCurrencyEnabled" :amount="user.balance" />
                    <span v-else>{{ currencySymbol }} {{ user.balance.toFixed(2) }}</span>
                  </div>
                </div>
                <router-link :to="{ name: 'Profile', query: { tab: 'account-balance' } }" class="balance-add"
                  >+
                </router-link>
              </div>
            </div>
            <div class="profile-info-right">
              <div class="steam-id">
                <div class="steam-id-label">Steam ID:</div>
                <div class="steam-id-value">{{ user.steamId || 'N/\A' }}</div>
                <img
                  src=".././assets/copy-icon.svg"
                  alt=""
                  class="steam-id-copy"
                  @click="copyToClipboard(user.steamId || 'N/A')"
                />
              </div>
            </div>
          </div>
          <div class="profile-tabs">
            <div
              class="tab-item"
              :class="{ active: activeTab === 'profile-settings' }"
              @click="updateActiveTab('profile-settings')"
            >
              Profile Settings
            </div>
            <div
              class="tab-item"
              :class="{ active: activeTab === 'account-balance' }"
              @click="updateActiveTab('account-balance')"
            >
              Account Balance
            </div>
            <div
              class="tab-item"
              :class="{ active: activeTab === 'deposit-history' }"
              @click="updateActiveTab('deposit-history')"
            >
              Deposit History
            </div>
            <div
              class="tab-item"
              :class="{ active: activeTab === 'purchase-history' }"
              @click="updateActiveTab('purchase-history')"
            >
              Purchase History
            </div>
            <div v-if="$parent.offerEnabled" class="tab-item" :class="{ active: activeTab === 'my-offers' }" @click="updateActiveTab('my-offers')">
              My Offers
            </div>
          </div>
          <div class="profile-tab-content">
            <ProfileSettings v-if="activeTab === 'profile-settings'" />
            <AccountBalance
              :minAmount="$parent.minAmount"
              :topUpAmounts="$parent.topUpAmounts"
              :paymentMethods="$parent.paymentMethods"
              v-if="activeTab === 'account-balance'"
            />
            <DepositHistory v-if="activeTab === 'deposit-history'" />
            <MyOffersTab v-if="activeTab === 'my-offers'" />
            <PurchaseHistory v-if="activeTab === 'purchase-history'" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
  import ProfileSettings from '../components/tabs/ProfileSettings.vue'
  import AccountBalance from '../components/tabs/AccountBalance.vue'
  import DepositHistory from '../components/tabs/DepositHistory.vue'
  import PurchaseHistory from '../components/tabs/PurchaseHistory.vue'
  import MyOffersTab from '../components/offers/MyOffersTab.vue'
  import InternalAmount from '../components/prices/InternalAmount.vue'
  import { copyToClipboard } from '../utils/helpers'
  import { mapState, mapGetters, mapActions } from 'vuex'
  export default {
    name: 'Profile',
    props: {
      activeTab: {
        type: String,
        required: true
      }
    },
    components: {
      ProfileSettings,
      AccountBalance,
      DepositHistory,
      PurchaseHistory,
      MyOffersTab,
      InternalAmount
    },
    data: function () {
      return {
        email: '',
        name: '',
        surname: '',
        phone: '',
        profileUpdateSuccessMessaage: '',
        profileUpdateErrorMessaage: '',
        passUpdateSuccessMessaage: '',
        passUpdateErrorMessaage: '',
        phoneFull: '',
        convertedShortName: '',
        countryCode: '',
        countryCodeList: [],
        profilePhone: '',

        countryOptions: [],
        orderHistory: []
      }
    },
    mounted() {
      if (this.activeTab === 'my-offers' && !this.$parent.offerEnabled) {
        this.$router.push({ name: 'Profile', query: { tab: 'account-balance' } })
      }
      if (this.$parent.isAuth) {
        this.orderHistory = this.$parent.orderHistory

        // Fetch offer history when the component mounts
        if (this.activeTab === 'my-offers') {
          this.fetchOfferHistory()
        }
      } else {
        this.$router.push({ name: 'Home' })
        this.$parent.openSignInModal()
      }
    },
    watch: {
      activeTab(newVal) {
        if (newVal === 'my-offers') {
          if (!this.$parent.offerEnabled) {
            this.$router.push({ name: 'Profile', query: { tab: 'account-balance' } })
            return
          }
          this.fetchOfferHistory()
        }
      },
      '$parent.offerEnabled'(newVal) {
        if (!newVal && this.activeTab === 'my-offers') {
          this.$router.push({ name: 'Profile', query: { tab: 'account-balance' } })
        }
      }
    },
    computed: {
      ...mapState('user', ['user']),
      ...mapGetters('user', ['fullName']),
      ...mapGetters('app', ['currencySymbol', 'internalCurrencyEnabled'])
    },
    methods: {
      ...mapActions('user', ['fetchAuthStatus']),
      ...mapActions('offers', ['fetchOfferHistory']),
      copyToClipboard,
      updateActiveTab(tab) {
        this.$router.push({ query: { tab } })
      },
      getShortNameByPhoneCode(phoneCode, codeList) {
        for (let i = 0; i < codeList.length; i++) {
          const countryCode = Object.keys(codeList[i])[0]
          const codeValue = codeList[i][countryCode].code
          if (codeValue == phoneCode) {
            this.convertedShortName = countryCode
          }
        }
      },
      getSymbolsBeforeSpace(inputString) {
        const regex = /^[^\s]+/
        const match = inputString.match(regex)

        if (match) {
          return match[0]
        } else {
          return '' // Return an empty string if no symbols are found
        }
      },
      phoneDataUpdate(e) {
        this.phoneFull = e.formatInternational
      }
    }
  }
</script>
